import { ExtraLabourTable, LabourTable } from '@components';
import { ServiceOrder, ServiceOrderExtra } from '@services';
import { Col, Row } from 'antd';
import React from 'react';

interface IProps {
  hideAction?: boolean;
  serviceOrders: ServiceOrder[];
  serviceOrderExtras: ServiceOrderExtra[];
  handleServiceOrderDelete?: (id: string) => void;
  handleServiceOrdersUpdate?: (serviceOrders: ServiceOrder) => void;
}

export const InvoiceBodyDetails: React.FC<IProps> = ({
  hideAction,
  serviceOrders,
  serviceOrderExtras,
  handleServiceOrderDelete,
  handleServiceOrdersUpdate,
}) => {
  return (
    <>
      <Row>
        <Col span={24}>
          <LabourTable
            hideAction={hideAction}
            serviceOrders={serviceOrders}
            handleServiceOrderDelete={handleServiceOrderDelete}
            handleServiceOrdersUpdate={handleServiceOrdersUpdate}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col span={24}>
          <ExtraLabourTable
            hideAction={hideAction}
            serviceOrders={serviceOrders}
            serviceOrderExtras={serviceOrderExtras}
            handleServiceOrdersUpdate={handleServiceOrdersUpdate}
          />
        </Col>
      </Row>
    </>
  );
};
